import AutomaticChip from './AutomaticChip';

export default AutomaticChip;
